<div class="page-container">
  <div [@fadeInUp] class="login-card">
    <div class="logo-container">
      <img src="./assets/img/logo-dark.png" />
    </div>

    <div [formGroup]="formGroup" class="form-container" (keyup.enter)="send()">
      <div>
        <mat-form-field>
          <mat-label>E-Mail</mat-label>
          <input matInput required formControlName="email" />
          <mat-error *ngIf="formGroup.controls.email.hasError('required')">We need an email address to log you in</mat-error>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Mot de passe</mat-label>
          <input matInput [type]="inputType" formControlName="password" required />

          <button type="button" mat-icon-button matSuffix (click)="toggleVisibility()" matTooltip="Toggle Visibility">
            <mat-icon *ngIf="visible">visibility</mat-icon>
            <mat-icon *ngIf="!visible">visibility_off</mat-icon>
          </button>

          <mat-error *ngIf="!formGroup.controls.password.valid">Mot de passe obligatoire</mat-error>
        </mat-form-field>
      </div>

      <div class="remember-container">
        <mat-checkbox class="caption" (change)="setRemenber($event)" [checked]="remember" color="primary">Remember Me</mat-checkbox>
        <a class="caption" [routerLink]="['/forgot-password']">Mot de passe oublie</a>
      </div>

      <div class="form-action">
        <button type="button" mat-raised-button (click)="send()">Se connecter</button>
      </div>
    </div>
  </div>
</div>
